import React, { useState } from "react";
import { useTemplateStore } from "@/zustand/templateStore.js";
import s from "@/components/Inputs/Input.module.scss";
import cn from "@/utils/classNames.js";

const TextField = ({
  dataTestId,
  placeholder,
  error,
  name,
  type,
  width,
  value,
  margin,
  handleChange,
  icon,
  max,
  min,
  comment,
  autoComplete,
  register,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);

  return (
    <div className={s.inputContainer} style={{ backgroundColor: "transparent" }}>
      <div
        className={cn(
          s.input,
          s.input__text,
          error && s.input__error,
          isEnhancedContrast && s.enhancedContrast,
          isEnhancedContrast && error && s.enhancedContrast__error
        )}
      >
        <input
          data-testid={dataTestId}
          maxLength={max}
          max={max}
          min={min}
          className={s.styledInput}
          autoComplete={autoComplete}
          type={type}
          name={name}
          id={name}
          value={value}
          {...register(name)}
          onChange={(name) => {
            handleChange(name);
          }}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
        <label
          htmlFor={name}
          className={cn(
            s.styledLabel,
            value.length > 0 && s.styledLabel__active,
            isEnhancedContrast && s.styledLabel__enhancedContrast
          )}
        >
          {placeholder}
        </label>

        {icon && (
          <div
            className={s.input__img}
            onClick={() => {
              if (window.isMobile) {
                setIsVisible(!isVisible);
              }
            }}
            style={{
              backgroundImage: `url(${icon}`,
            }}
          >
            {comment && (
              <span className={s.input__comment} visible={isVisible.toString()}>
                {comment}
              </span>
            )}
          </div>
        )}
      </div>
      {error && <span className={s.formError}>{error}</span>}
    </div>
  );
};

export default TextField;
